import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import Request from "../../request";
import { Card, Tooltip, Icon, Divider, Row, Col, Button } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import _ from 'lodash';
import { FaUserCircle, FaClock, FaCalendarAlt, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import AddAppointmentDrawer from "../../components/drawers/addAppointmentDrawer";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

class Appointment extends React.Component {
    state = {
        total: 0,
        showAddAppointment: false
    };

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.loadAppointments(params);
            this.setState({ total: response.total });
            return resolve(response);
        })
    }


    closeAddAppointment = () => {
        this.setState({ showAddAppointment: false }, () => {
            this.table.current.reload();
        })
    }


    loadUsers = async () => {
        let activeUser = JSON.parse(localStorage.getItem('user'))
        let params = {
            results: 10000,
            count: 10000
        }
        params.sortField = 'name'
        params.sortOrder = 'ascend'
        params.userBranch = activeUser.userBranch
        params.active = true
        params.userType = { $ne: "Student" }
        let data = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] })
        let allUsers = []
        _.each(data.data, (user) => {
            allUsers.push({ _id: user._id, display: user.name })
        })

        this.setState({ allUsers })
    }

    componentDidMount() {
        this.loadUsers();
    }

    render() {
        let { total, allUsers, showAddAppointment } = this.state;

        const appointmentColumns = [
            {
                title: 'Sr.',
                key: 'serialNumber',
                width: 50,
                render: (text, record, index) => (
                    <div style={{ color: '#8c8c8c', fontWeight: 500 }}>{index + 1}</div>
                )
            },
            {
                title: 'Client Detail / Contact',
                key: 'name',
                width: 250,
                searchTextName: 'name',
                render: (text, record) => (
                    <div style={{ padding: '4px 0' }}>
                        <div style={{ fontWeight: 700, color: '#1890ff', fontSize: '14px', marginBottom: '4px' }}>
                            <FaUserCircle style={{ marginRight: 8, verticalAlign: 'middle' }} />
                            {record.name} <small style={{ color: '#bfbfbf', fontWeight: 400 }}>#{record.studentId}</small>
                        </div>
                        <div style={{ fontSize: '12px', color: '#595959' }}>
                            <div><FaPhoneAlt style={{ marginRight: 8, fontSize: '10px', color: '#8c8c8c' }} />{record.phoneNo}</div>
                            <div style={{ marginTop: 2 }}>
                                <FaEnvelope style={{ marginRight: 8, fontSize: '10px', color: '#8c8c8c' }} />
                                <span style={{ color: '#8c8c8c' }}>{record.email}</span>
                            </div>
                        </div>
                    </div>
                )
            },
            {
                title: 'Appointment Schedule',
                key: 'startDate',
                width: 200,
                searchTextName: `Appointment Date ${dateFormat}`,
                render: (text, record) => (
                    <div>
                        <div style={{ fontWeight: 600, color: '#262626' }}>
                            <FaCalendarAlt style={{ marginRight: 8, color: '#1890ff' }} />
                            {moment(record.startDate).format(dateFormat)}
                        </div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: 4 }}>
                            <FaClock style={{ marginRight: 8, color: '#faad14' }} />
                            {record.startTime}
                        </div>
                    </div>
                )
            },
            {
                title: 'Location & Subject',
                key: 'location',
                width: 180,
                searchTextName: 'Location & Subject',
                render: (text, record) => (
                    <div>
                        <div className="bg-blue" style={{
                            display: 'inline-block',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            marginBottom: 4
                        }}>
                            <FaMapMarkerAlt style={{ marginRight: 4 }} /> {record.location}
                        </div>
                        <div style={{ fontSize: '13px', fontWeight: 500, color: '#595959', paddingLeft: 4 }}>
                            {record.subject}
                        </div>
                    </div>
                )
            },
            {
                title: 'Attendee',
                key: 'attendees',
                width: 150,
                filters: allUsers && allUsers.map(x => ({ value: x._id, text: x.display })),
                render: (attendees) => (
                    <div>
                        {attendees && attendees.map(person => (
                            <div key={person} style={{
                                background: '#f5f5f5',
                                border: '1px solid #e8e8e8',
                                borderRadius: '15px',
                                padding: '2px 10px',
                                fontSize: '12px',
                                display: 'inline-block'
                            }}>
                                {person}
                            </div>
                        ))}
                    </div>
                )
            },
            {
                title: 'Created By',
                key: 'createdByUser',
                width: 180,
                render: (user) => (
                    <div style={{ fontSize: '12px' }}>
                        <div style={{ fontWeight: 600, color: '#595959' }}>{user.name}</div>
                        <div style={{ color: '#bfbfbf', fontSize: '11px' }}>
                            {moment(user.time).format(`${dateFormat} HH:mm A`)}
                        </div>
                    </div>
                )
            }
        ];

        return (
            <PageHeaderWrapper title={`Appointments List (${total})`}>
                {
                    showAddAppointment ?
                        <AddAppointmentDrawer onClose={this.closeAddAppointment} />

                        : null
                }
                <Card bordered={true} style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={22}></Col>
                        <Col span={2}>
                            <Tooltip title="Add Appointment" >
                                <Button icon="plus" type="primary" onClick={() => { this.setState({ showAddAppointment: true }) }} />
                            </Tooltip>
                        </Col>
                    </Row>
                </Card>
                <Card
                    bordered={false}
                    style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
                >
                    <TableComp
                        columns={appointmentColumns}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        id={'appointment'}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(Appointment);